/*
 * KW-601: Aris Options, Mindest- und Standardmenge.
 *
 * Aris hat für Klimaworld (Auftrag KW-390) einen Sonderzweig im App-JS: bei min < max wird
 * "Min quantity" als Vorbelegung benutzt und die Untergrenze auf 1 gesenkt. Das stammt aus der
 * Zeit vor dem Feld "Default quantity". Zusätzlich überschreibt Aris' Custom-Snippet im App-Embed
 * nach 600 ms die sichtbare Menge mit "min", ohne den Warenkorbwert anzupassen
 * (Anzeige 2, Warenkorb 5).
 *
 * Nur für Optionen mit explizit gesetzter "Default quantity" (und min < max) stellt dieses Skript
 * das dokumentierte Verhalten her: Vorbelegung = default_value_qty, Untergrenze = min_value_qty,
 * sichtbare Menge = Warenkorbmenge. Optionen ohne Default behalten das KW-390-Verhalten.
 *
 * Die Set-Daten liest es aus derselben Antwort, die Aris lädt (/search?view=apo), indem es fetch
 * mitliest. Entfernen, sobald Aris den Sonderzweig selbst anpasst.
 *
 * Loaded with defer on product templates only (layout/theme.liquid): the Aris app's own scripts
 * are deferred and come later in the document, so this patch is always in place first.
 */
(function () {
  if (!window.fetch || window.__cdxArisQtyFix) return;
  window.__cdxArisQtyFix = true;

  var QTY = 'avp-qty-input';
  var byKey = {};
  var observing = false;

  function toInt(v) {
    var n = parseInt(v, 10);
    return isNaN(n) ? 0 : n;
  }

  function remember(sets) {
    if (!Array.isArray(sets)) return;
    sets.forEach(function (set) {
      (set && set.options || []).forEach(function (o) {
        var min = toInt(o.min_value_qty);
        var max = toInt(o.max_value_qty);
        var def = toInt(o.default_value_qty);
        // Gleiche Bedingung wie der Aris-Sonderzweig (min < max), plus explizites Default.
        if (!o.key || def <= 0 || !(min < max)) return;
        byKey[o.key] = { min: Math.max(min, 1), max: max, def: Math.min(Math.max(def, min), max) };
      });
    });
    if (!Object.keys(byKey).length) return;
    scan(document);
    observe();
  }

  function cfgOf(input) {
    var opt = input.closest('.avp-option');
    return opt && byKey[opt.getAttribute('key')];
  }

  function grid(input) {
    return input.closest('.avp-value-grid');
  }

  function isChecked(input) {
    var g = grid(input);
    var v = g && g.querySelector('input[field-name]');
    return !!(v && v.checked);
  }

  function syncButtons(input) {
    var cfg = input.__cdxQty;
    var g = grid(input);
    if (!cfg || !g) return;
    var cut = g.querySelector('.avp-qty-cut');
    if (cut && toInt(input.value) <= cfg.min) cut.setAttribute('disabled', 'disabled');
  }

  // Menge, die Aris gerade im versteckten Warenkorbfeld führt ("Wert * N"), sonst null.
  function cartQty(input) {
    var g = grid(input);
    var v = g && g.querySelector('input[field-name]');
    if (!v) return null;
    var fields = document.getElementsByName('properties[' + v.getAttribute('field-name') + ']');
    for (var i = 0; i < fields.length; i++) {
      var parts = fields[i].value.split(v.value + ' * ');
      if (parts.length > 1) return toInt(parts[1]);
    }
    return null;
  }

  // Warenkorbwert und Preis über Aris' eigenen blur-Handler an die sichtbare Menge angleichen.
  // Nur wenn beide auseinanderliegen: der blur lässt Aris' Custom-Snippet die Menge auch
  // als "gemerkte Menge" speichern, das soll nicht für jede Skript-Änderung passieren.
  function commit(input) {
    if (input.__cdxCommitting) return;
    if (cartQty(input) !== toInt(input.value)) {
      input.__cdxCommitting = true;
      input.dispatchEvent(new Event('blur'));
      input.__cdxCommitting = false;
    }
    setTimeout(function () { syncButtons(input); }, 0);
  }

  function clamp(input) {
    var cfg = input.__cdxQty;
    var val = toInt(input.value);
    if (val < cfg.min && isChecked(input)) input.value = cfg.min;
    else if (val > cfg.max) input.value = cfg.max;
  }

  function fix(input) {
    if (input.__cdxQty) return;
    var cfg = cfgOf(input);
    if (!cfg) return;
    input.__cdxQty = cfg;
    var late = input.getAttribute('default-qty') !== null && toInt(input.value) !== cfg.def;
    input.setAttribute('default-qty', cfg.def);
    input.setAttribute('data-min', cfg.min);
    input.setAttribute('min', cfg.min);
    // Nur falls Aris schon vor uns gerendert hat und die Menge noch auf "min" steht.
    if (late && isChecked(input) && toInt(input.value) < cfg.def && input !== document.activeElement) {
      input.value = cfg.def;
      commit(input);
    }
    syncButtons(input);
  }

  function scan(root) {
    var list = root.getElementsByClassName ? root.getElementsByClassName(QTY) : [];
    for (var i = 0; i < list.length; i++) fix(list[i]);
  }

  function observe() {
    if (observing) return;
    observing = true;
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        if (r.type === 'attributes') {
          var t = r.target;
          // Aris' Custom-Snippet setzt data-min nach 600 ms auf 1.
          if (t.__cdxQty && toInt(t.getAttribute('data-min')) !== t.__cdxQty.min) {
            t.setAttribute('data-min', t.__cdxQty.min);
          }
          return;
        }
        r.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.classList.contains(QTY)) fix(n);
          else scan(n);
        });
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-min']
    });

    // Minus-Button: nicht unter die Mindestmenge (Aris' Sonderzweig erlaubt bis 1 bzw. 0).
    document.addEventListener('click', function (e) {
      var cut = e.target.closest && e.target.closest('.avp-qty-cut');
      var g = cut && cut.closest('.avp-value-grid');
      var input = g && g.querySelector('.' + QTY);
      if (!input || !input.__cdxQty) return;
      if (toInt(input.value) <= input.__cdxQty.min) {
        e.preventDefault();
        e.stopImmediatePropagation();
        cut.setAttribute('disabled', 'disabled');
        return;
      }
      setTimeout(function () { syncButtons(input); }, 0);
    }, true);

    // Getippte Werte vor Aris' eigenem blur-Handler auf min/max begrenzen.
    document.addEventListener('blur', function (e) {
      var input = e.target;
      if (input && input.__cdxQty && !input.__cdxCommitting) clamp(input);
    }, true);

    // Aris' Custom-Snippet setzt die Menge per Skript (untrusted input event), ohne den
    // Warenkorbwert zu aktualisieren. Begrenzen und übernehmen.
    document.addEventListener('input', function (e) {
      var input = e.target;
      if (!input || !input.__cdxQty || e.isTrusted) return;
      clamp(input);
      commit(input);
    }, true);
  }

  var nativeFetch = window.fetch;
  window.fetch = function (resource) {
    var promise = nativeFetch.apply(window, arguments);
    try {
      var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
      if (url.indexOf('view=apo') > -1) {
        promise
          .then(function (res) { return res.clone().json(); })
          .then(remember)
          .catch(function () {});
      }
    } catch (err) {}
    return promise;
  };
})();
